import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/images/WasteWatch.png"; 
import "./Header.css"; 

const Header = () => {
  return (
    <nav className="navbar navbar-expand-lg custom-navbar px-4">
      <Link className="navbar-brand d-flex align-items-center" to="/">
        <img 
          src={logo} 
          alt="WasteWatch Logo" 
          className="logo"
        />
        WasteWatch
      </Link>

      <button 
        className="navbar-toggler" 
        type="button" 
        data-bs-toggle="collapse" 
        data-bs-target="#nav" 
        aria-controls="nav" 
        aria-expanded="false" 
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>

      <div className="collapse navbar-collapse" id="nav">
        <div className="nav-buttons ms-auto">
          <Link className="btn btn-outline-custom me-2" to="/login">Login</Link>
          <Link className="btn btn-custom" to="/signup">Signup</Link>
        </div>
      </div>
    </nav>
  );
};

export default Header;
